import IntegrationCallStepResourcePagingResultModel from '../../generated/types/model/resource/IntegrationCallStepResourcePagingResultModel';

export default class IntegrationCallStepResourcePagingResultViewModel extends IntegrationCallStepResourcePagingResultModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
